module.exports = __webpack_public_path__ + "static/media/18.6d21944d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/18.png
// module id = 384
// module chunks = 0